import { useRef, useState } from "react";
import brandLogo from "./assets/brandie-logo.png";
import "./index.css";

export default function App() {
  const [url, setUrl] = useState("");
  const [timeoutMs, setTimeoutMs] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [playableUrl, setPlayableUrl] = useState<string | null>(null);
  const formRef = useRef<HTMLFormElement | null>(null);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const trimmed = url.trim();
    if (!trimmed) return;
    setError(null);
    setIsSubmitting(true);

    const form = event.currentTarget;
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (typeof value === "string") {
        body.set(key, value);
      }
    });

    let response: Response;
    try {
      response = await fetch("/api/extract", {
        method: "POST",
        body,
      });
    } catch (fetchError) {
      const message =
        fetchError instanceof Error
          ? fetchError.message
          : "Failed to reach the server.";
      setError(message);
      setIsSubmitting(false);
      return;
    }

    if (!response.ok) {
      const raw = await response.text();
      let message = "Failed to extract playable.";
      try {
        const parsed = raw ? JSON.parse(raw) : null;
        message = parsed?.error || message;
      } catch {
        if (raw) message = raw;
      }
      setError(message);
      setIsSubmitting(false);
      return;
    }

    const payload = await response.json().catch(() => null);
    const nextUrl = payload?.previewUrl || payload?.url;
    if (!nextUrl || typeof nextUrl !== "string") {
      setError("Unexpected response from server.");
      setIsSubmitting(false);
      return;
    }

    setPlayableUrl(nextUrl);
    setIsSubmitting(false);
  }

  return (
    <div className="shell">
      <div className="brand-header">
        <img className="brand-logo" src={brandLogo} alt="Brandie logo" />
        <div className="brand">Brandie</div>
        <div className="subtitle">restyling playables for fun</div>
      </div>
      <div className="panel">
        <h2>
          <span className="icon">&#9889;</span> Extract Game
        </h2>
        <form
          method="post"
          action="/api/extract"
          onSubmit={handleSubmit}
          ref={formRef}
        >
          <div className="input-wrap">
            <input
              id="url-input"
              type="url"
              name="url"
              required
              placeholder="Paste Protected Preview Link..."
              autoComplete="off"
              spellCheck={false}
              value={url}
              onChange={(event) => setUrl(event.target.value)}
            />
          </div>
          <div className="controls">
            <label>
              Timeout (ms)
              <input
                type="number"
                name="timeoutMs"
                placeholder="30000"
                value={timeoutMs}
                onChange={(event) => setTimeoutMs(event.target.value)}
              />
            </label>
          </div>
          <button className="button" type="submit">
            {isSubmitting ? "Processing..." : "Bypass & Initialize"}
          </button>
        </form>
        {error ? <div className="error">{error}</div> : null}
        {playableUrl ? (
          <div className="preview">
            <div className="preview-header">
              <span>Preview</span>
              <a href={playableUrl} target="_blank" rel="noreferrer">
                Open in new tab
              </a>
            </div>
            <div className="preview-frame">
              <iframe title="Playable preview" src={playableUrl} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
